import * as persistentStateActions from '../store/persistentState/persistentState.types';
import { actionWithNoId } from './eventDefinitions';

const tasksEventsMap = {
  [persistentStateActions.HIDE_WELCOME_MESSAGE]: actionWithNoId('Tasks'),
};

export default tasksEventsMap;
